import { useMutation, useQueryClient } from "@tanstack/react-query"
import { addPayment } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useAddPayment(orderId: string) {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: { type: "BUYER_TO_ADMIN" | "ADMIN_TO_SELLER"; amount: number; referenceId: string }) => {
      if (!accessToken) throw new Error("Not authenticated")
      return addPayment(orderId, payload, accessToken)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["order-payments", orderId] })
      queryClient.invalidateQueries({ queryKey: ["buyer-order-detail", orderId] })
    },
  })
}
